<template>
  <div class="service-module">
    <div v-movein class="service-module-content-title">核心产品</div>
    <div v-movein class="service-module-content-sub-title">PRODUCT</div>
    <div v-movein class="service-module-content-description">
      更高的质量，更优的服务，专注于客户的使用价值与体验。
    </div>
    <div class="service-item-wrapper">
      <div
        v-for="(item, index) in list"
        :key="index"
        v-movein
        class="service-item"
        @click="handleToServiceDetail(item.id)"
      >
        <div class="service-item-title">
          <img
            v-lazyload
            class="service-item-icon"
            :src="item.icon"
            alt="icon"
            srcset=""
          />
          {{ item.title }}
        </div>
        <div class="service-item-description">
          <div class="service-item-description-text">
            {{ item.description }}
          </div>
          <span class="right-arrow">→</span>
        </div>
      </div>
      <div v-movein class="more-service">
        <div class="more-service-content">
          <div class="more-service-text">
            <div class="more-service-title">更多产品</div>
            <div class="more-service-waiting">让我们敬请期待</div>
          </div>
          <img v-lazyload class="more-service-image" :data-src="rocketImage" />
        </div>
        <img
          v-lazyload
          class="more-background no-right-click"
          :data-src="moreImg"
          alt=""
          srcset=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import warningIcon from '@/assets/images/service/warning.png'
import caseIcon from '@/assets/images/service/case.png'
import clueIcon from '@/assets/images/service/clue.png'
import autoStopIcon from '@/assets/images/service/autoStop.png'
import dataAnalysisIcon from '@/assets/images/service/dataAnalysis.png'
import controlIcon from '@/assets/images/service/control.png'
import collaborationIcon from '@/assets/images/service/collaboration.png'
import cardIcon from '@/assets/images/service/card.png'
import enterpriseIcon from '@/assets/images/service/enterprise.png'
import rocketImage from '@/assets/images/solution/rocket.svg'
import moreImg from '@/assets/images/solution/more-solution.svg'
export default {
  name: 'ServiceModule',
  data() {
    return {
      rocketImage,
      moreImg,
      list: [
        {
          id: '1',
          title: '预警劝阻平台',
          description: '汇聚诈骗预警、自动下发、回访劝阻、预警止付。',
          icon: warningIcon
        },
        {
          id: '2',
          title: '案件侦办平台',
          description:
            '实现对案件侦办过程的全流程管理，支持电诈案件和传统案件。',
          icon: caseIcon
        },
        {
          id: '3',
          title: '线索侦研平台',
          description: '实现跨部门的线索下发反馈和任务协同。',
          icon: clueIcon
        },
        {
          id: '4',
          title: '自动止付（反制通）',
          description:
            '一键对止付卡号、止付人员名下银行卡、第三方账号进行快速止付。',
          icon: autoStopIcon
        },
        {
          id: '5',
          title: '数据智能分析（小刀）',
          description: '针对通讯、资金、关系、轨迹等数据进行智能分析。',
          icon: dataAnalysisIcon
        },
        {
          id: '6',
          title: '防控治理警务平台',
          description: '建立一套新型的警务运行生态系统，为基层提供全面服务。',
          icon: controlIcon
        },
        {
          id: '7',
          title: '安全协作平台',
          description:
            '解决反诈业务参与方公安、银行、运营商等单位数据连通和共享。',
          icon: collaborationIcon
        },
        {
          id: '8',
          title: '两卡治理小程序',
          description:
            '构建安全高效的警银、警信联动通道，实现银行卡、电话卡涉诈风险核验',
          icon: cardIcon
        },
        {
          id: 9,
          title: '企业申诉救济',
          description: '专为解决企业账户被冻结问题而打造的一站式服务系统。',
          icon: enterpriseIcon
        }
      ]
    }
  },
  methods: {
    handleToServiceDetail(id) {
      this.$router.push({
        name: 'productDetail',
        params: {
          id
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.service-module {
  position: relative;
  margin: 0 auto;
  max-width: 1200px;
  min-height: 572px;
  padding-bottom: 143px;
  padding-top: 176px;
  .service-module-content-title {
    font-family: SourceHanSansCN;
    font-weight: 600;
    font-size: 48px;
    line-height: 64px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: transparent;
    background: linear-gradient(
      167.78deg,
      #ffffff 68.32%,
      rgba(255, 255, 255, 0.38) 96.13%
    );
    background-clip: text;
    text-shadow: 0px 2px 6px #00000014, 0px 6px 2px #0000000f;
  }
  .service-module-content-sub-title {
    display: flex;
    font-family: Times;
    font-weight: 500;
    font-size: 12px;
    line-height: 32px;
    letter-spacing: 0%;
    text-transform: uppercase;
    text-align: center;
    color: #ffffff;
    justify-content: center;
    align-items: center;
    &::before,
    &::after {
      display: inline-block;
      content: '';
      width: 14px;
      height: 2px;
      background-color: #f02528;
      vertical-align: middle;
      margin: 0 9px;
    }
  }
  .service-module-content-description {
    margin-top: 24px;
    padding: 0 16px;
    font-weight: 500;
    font-size: 16px;
    line-height: 48px;
    letter-spacing: 0%;
    text-align: center;
    color: #ffeff0;
  }
  .service-item-wrapper {
    display: flex;
    display: -ms-flexbox;
    margin-top: 100px;
    width: 100%;
    flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    justify-content: space-between;
    -ms-flex-pack: space-between;
    align-items: start;
    .service-item {
      position: relative;
      margin-bottom: 33px;
      padding: 24px;
      height: 140px;
      width: 284px;
      border-radius: 16px;
      background: #2b2524;
      transition: all 0.3s;
      overflow: hidden;
      cursor: pointer;
      &:hover {
        transform: translateY(-6px);
        &::before {
          opacity: 1;
        }
        .service-item-description {
          .service-item-description-text {
            color: #ffe1e0;
          }
          .right-arrow {
            color: #ffffff;
          }
        }
      }
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, #ff565d 0%, #2b2524 100%);
        opacity: 0;
        transition: opacity 0.3s;
        z-index: 0;
      }
      .service-item-title {
        position: relative;
        height: 32px;
        line-height: 32px;
        color: #f7f8f8;
        font-size: 16px;
        font-weight: 500;
        .service-item-icon {
          margin-right: 6px;
          height: 32px;
          width: 32px;
          vertical-align: middle;
        }
      }
      .service-item-description {
        position: relative;
        margin-top: 12px;
        .service-item-description-text {
          font-size: 14px;
          line-height: 24px;
          width: 215px;
          color: #8a8f98;
          transition: all 0.3s;
        }
        .right-arrow {
          position: absolute;
          bottom: 0;
          right: 0;
          font-size: 16px;
          font-weight: 600;
          line-height: 23px;
          color: #8a8f98;
          transition: all 0.3s;
        }
      }
    }
    .more-service {
      position: relative;
      display: flex;
      display: -ms-flexbox;
      width: 895px;
      height: 140px;
      justify-content: space-around;
      -ms-flex-pack: space-around;
      align-items: center;
      -ms-align-items: center;
      overflow: hidden;
      .more-background {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 0;
      }
      .more-service-content {
        position: relative;
        display: flex;
        display: -ms-flexbox;
        width: 420px;
        height: 48px;
        justify-content: space-between;
        -ms-flex-pack: space-between;
        align-items: center;
        -ms-align-items: center;
        z-index: 1;
        .more-service-title {
          font-weight: 400;
          font-size: 14px;
          line-height: 15px;
          letter-spacing: 0px;
          color: #ddcaca;
        }
        .more-service-waiting {
          margin-top: 8px;
          font-weight: 500;
          font-size: 18px;
          line-height: 26px;
          letter-spacing: 0px;
          text-align: center;
          color: #ffffff;
        }
        .more-service-image {
          width: 48px;
        }
      }
    }
  }
}
// and (min-width: 1024.02px)
@media screen and (min-width: 920.02px) and (max-width: 1200px) {
  .service-module {
    .service-item-wrapper {
      justify-content: space-around;
      padding: 0 32px;
    }
  }
}
@media screen and (max-width: 920px) {
  .service-module {
    .service-item-wrapper {
      justify-content: space-around;
      padding: 0 32px;
      .more-service {
        width: 284px;
        .more-service-content {
          justify-content: space-around;
        }
      }
    }
  }
}
</style>
